<template>
  <div class="main-menu">
    <div class="logo">
      <router-link to="/">
        <img src="/assets/marketpro-logo.svg" class="logo-dark" alt="Logo Marketpro" width="180" />
      </router-link>
    </div>
    <div class="nav">
      <v-list color="primary" dark>
        <template v-for="item in menuItems">
          <v-list-item v-if="!item.children" :key="item.title" :to="item.url">
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item>
          <v-list-group v-else :key="item.title" :prepend-icon="item.icon" color="white">
            <template v-slot:activator>
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </template>

            <v-list-item v-for="child in item.children" :key="child.title" :to="child.url">
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      menuItems: [
        {
          title: "Commandes clients",
          icon: "mdi-cart",
          url: "/orders/list"
        },
        {
          title: "Comptes",
          icon: "mdi-domain",
          url: "/account/list"
        },
        {
          title: "Services",
          icon: "mdi-wrench",
          url: "/services/list"
        },
        {
          title: "Options",
          icon: "mdi-cog",
          children: [
            {
              title: "Configuration des emails",
              icon: "mdi-email-multiple",
              url: "/options/mailings"
            },
            {
              title: "Pages Statiques",
              icon: "mdi-file-document-outline",
              url: "/options/static"
            }
          ]
        },
        {
          title: "Déconnexion",
          icon: "mdi-logout-variant",
          url: "/logout"
        }
      ]
    };
  }
};
</script>

<style lang="less">
.main-menu {
  display: flex;
  flex-direction: column;
  .logo {
    flex: 0 0 200px;
    img {
      display: block;
      margin: 30px auto;
    }
  }
  .nav {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ul {
      li {
        a {
          color: white;
        }
      }
    }
  }
}
</style>